import type { InvoiceConfig } from "@/interfaces/invoiceConfig";

/**
 * Invoice configuration for Lady's Harmony club.
 * Filename matches club slug: ladysharmony
 */
export const ladysharmonyInvoiceConfig: InvoiceConfig = {
  title: "FACTURE D'ABONNEMENT",
  headerText: "Lady's Harmony - Espace bien-être",
  footerText: "Merci pour votre confiance. À bientôt au club !",
  address: "45 Boulevard Mohammed V, Casablanca",
  contact: {
    phone: "+212 5 22 33 44 55",
    email: "info@ladysharmony.ma",
  },
  signatureLabel: "Signature",
  forClubLabel: "Pour Lady's Harmony",
};
